import * as queries from '@queries/utils';

export const fetchSalesItems = () => queries.getQuery('/api/sales-items', 'populate=*,idChantier.idContact,idClient,sales_details,sales_item,files');

export const createSalesItems = (salesItems) => queries.postQuery('/api/sales-items', salesItems);

export const updateSalesItems = (salesItems) => queries.putQuery(`/api/sales-items`, salesItems);

export const deleteSalesItems = (salesItemsToDelete) => queries.deleteQuery(`/api/sales-items`, salesItemsToDelete);
